import { render, staticRenderFns } from "./WaitingTehBookingNoVisitPopup.vue?vue&type=template&id=442bbd54&scoped=true"
import script from "./WaitingTehBookingNoVisitPopup.vue?vue&type=script&lang=js"
export * from "./WaitingTehBookingNoVisitPopup.vue?vue&type=script&lang=js"
import style0 from "./WaitingTehBookingNoVisitPopup.vue?vue&type=style&index=0&id=442bbd54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442bbd54",
  null
  
)

export default component.exports